import Axios from 'axios';


var headers = {
    'Content-Type': 'application/json',


}
export default {


    getAll() {
        const BASE_URL = '/public/api';
        //console.log(BASE_URL)
        return Axios.get(BASE_URL + '/customers', { headers: headers })
    },


}